import { CircularProgress } from '@mui/material';
import React, { ReactNode } from 'react';

export interface LoadingProps {
  size: 'SM' | 'MD' | 'LG' | 'XL' | 'XXL';
  color?: 'primary' | 'inherit';
  fullPage?: boolean;
}

enum SpinnerSize {
  SM = '.75rem',
  MD = '1rem',
  LG = '1.125rem',
  XL = '2.5rem',
  XXL = '7.5rem',
}

const FullPageWrapper = ({ children }: { children: ReactNode }): JSX.Element => (
  <div className="w-full h-full flex justify-center items-center">{children}</div>
);

export default function Loading({ size, color = 'primary', fullPage }: LoadingProps): JSX.Element {
  const Wrapper = fullPage ? FullPageWrapper : React.Fragment;

  return (
    <Wrapper>
      <CircularProgress aria-label="loading" color={color} size={SpinnerSize[size]} />
    </Wrapper>
  );
}
